module.exports = __webpack_public_path__ + "static/media/zebra.6d5e0dd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/zebra.svg
// module id = 626
// module chunks = 6